import { call, put } from 'redux-saga/effects';
import nsToken from '@netsapiens/netsapiens-js/dist/token';
import { setLoading } from '../../../state/chat/chatSlice';
import { updateMessageCardVideoAction } from '../../cardManagment/updateMessageCardVideo/action';
import { markReadAction } from '../markRead/action';
import sendMessage from '../sendMessage/sendMessage';

export default function* declineVideo({ payload }) {
  const debug = false;
  if (debug) console.debug('in declineVideo params:', payload);

  const { sessionId, session } = payload;

  try {
    // Get authentication token (similar to startVideo.js)
    const decodedToken = yield call(nsToken.getDecoded);

    // Prepare message parameters to match startVideo.js structure
    const args = {
      object: 'message',
      action: 'create',
      type: 'chat-video-decline',
      domain: decodedToken.domain,
      user: decodedToken.user,
      session_id: sessionId,
      message: 'video-decline',
      destination: session.contactArr.map((obj) => obj.user).join(','),
    };

    if (debug) console.debug('Sending video decline message with args:', args);

    // Use the sendMessage saga to send the message
    yield call(sendMessage, { payload: args });

    // Clean up the UI after sending the message
    yield put(updateMessageCardVideoAction({
      sessionId,
      videoInvite: false,
      videoId: null,
      videoInviteFrom: null,
    }));

    yield put(markReadAction({ session }));
  } catch (error) {
    console.error('Error declining video:', error);
    // Handle error gracefully - still clean up UI even if API fails
    yield put(updateMessageCardVideoAction({
      sessionId,
      videoInvite: false,
      videoId: null,
      videoInviteFrom: null,
    }));
  }

  yield put(setLoading(false));
}
